import React, { useState } from 'react';
import { Card, Form, Input, Button, Switch, Space, InputNumber, Alert, Select, TimePicker, Col, Row, Upload } from 'antd';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { CheckCircleOutlined, CloseCircleOutlined, UploadOutlined } from '@ant-design/icons';
import { createAgent } from '../../store/slices/userSlice';
import Password from 'antd/es/input/Password';
import DayAndTime from '../../components/DayAndTime';

const AddAgent = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");
    const [fileList, setFileList] = useState([]);
    const onSubmit = async (values) => {
        setLoading(true);
        setAlertMessage("");
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));

            // const formatted = values.availability.map(item => ({
            //     day: item.day,
            //     start_time: item.start_time.format("HH:mm"),
            //     end_time: item.end_time.format("HH:mm")
            // }));

            // const formattedWorkingHours = values.working_hours.map(item => ({
            //     day: item.day,
            //     start_time: item.start_time.format("HH:mm"),
            //     end_time: item.end_time.format("HH:mm")
            // }));

            const formData = new FormData();

            formData.append('first_name', values?.first_name);
            formData.append('last_name', values?.last_name);
            formData.append('email', values?.email);
            formData.append('phone', values?.phone);
            formData.append('gender', values?.gender);
            formData.append('role_type', 'agent');  // static value
            formData.append('address', values?.address);
            formData.append('password', values?.password);

            // If 'image' is a file object (from AntD Upload)
            if (values?.image && values.image.file) {
                formData.append('image', values?.image?.file);
            }

            const resultAction = await dispatch(createAgent(formData))

            if (createAgent.fulfilled.match(resultAction)) {
                navigate('/agents')
            } else {
                console.log(resultAction?.payload)
                setAlertMessage(resultAction?.payload?.error || 'Error creating agent');
                setAlertType('error');
            }
        } catch (error) {
            setAlertMessage('Error creating agent.');
            setAlertType('error');
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (info) => {
        setFileList(info.fileList.slice(-1));
    };

    const beforeUpload = (file) => {
        const isImage = file.type.startsWith('image/');
        if (!isImage) {
            setAlertMessage('You can only upload image files!');
            setAlertType('error');
            return Upload.LIST_IGNORE;
        }
        return false; // prevent auto upload
    };

    return (
        <div>
            <h1 style={{ marginBottom: 24 }}>Agent</h1>
            <Card title="Add Agent" style={{ marginBottom: 16 }}>
                {alertMessage && (
                    <Alert
                        message={alertMessage}
                        type={alertType}
                        showIcon
                        icon={alertType === 'success' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                        closable
                        onClose={() => setAlertMessage('')}
                        style={{
                            marginBottom: 24,
                            borderRadius: '8px',
                        }}
                    />
                )}
                <Form
                    layout="vertical"
                    onFinish={onSubmit}
                    form={form}
                    initialValues={{
                        gender: '',
                        availability: [{}],
                        working_hours: [{}]
                    }}
                >
                    <Form.Item
                        label="First Name"
                        name="first_name"
                        rules={[{ required: true, message: 'Please input first name!' }]}
                    >
                        <Input placeholder="Enter first name" />
                    </Form.Item>
                    <Form.Item
                        label="Last Name"
                        name="last_name"
                        rules={[{ required: true, message: 'Please input last name!' }]}
                    >
                        <Input placeholder="Enter last name" />
                    </Form.Item>
                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[
                            { required: true, message: 'Please enter your email' },
                            { type: 'email', message: 'Please enter a valid email' }
                        ]}
                    >
                        <Input placeholder="Enter email" />
                    </Form.Item>
                    <Form.Item
                        label="Address"
                        name="address"
                        rules={[{ required: true, message: 'Please input address!' }]}
                    >
                        <Input placeholder="Enter address" />
                    </Form.Item>
                    <Form.Item
                        label="Gender"
                        name="gender"
                        rules={[
                            { required: true, message: 'Please select gender' },
                        ]}
                    >
                        <Select
                            options={[
                                { value: '', disabled : true, label: <span>Select gender</span> },
                                { value: 'male', label: <span>Male</span> },
                                { value: 'female', label: <span>Female</span> },
                                { value: 'other', label: <span>Othder</span> },
                            ]}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Phone"
                        name="phone"
                        rules={[{ required: true, message: 'Please input phone!' }]}
                    >
                        <InputNumber placeholder="Enter phone" style={{ width : "100%" }} />
                    </Form.Item>
                    <Form.Item
                        label="Password"
                        name="password"
                        rules={[{ required: true, message: 'Please input password!' }]}
                    >
                        <Password placeholder="Enter password" />
                    </Form.Item>
                    <Form.Item label="Profile Image" name="image"  rules={[{ required: true, message: 'Please upload atleast one image' }]}>
                        <Upload
                        beforeUpload={beforeUpload}
                        fileList={fileList}
                        maxCount={1}
                        onChange={handleChange}
                        accept="image/*"
                        listType="picture"
                        >
                        <Button icon={<UploadOutlined />}>Select Images</Button>
                        </Upload>
                    </Form.Item>
                    {/* <Form.List name="availability">
                    </Form.List> */}
                    {/* <DayAndTime text="Availability" name="availability" btnText="Add Another Availability" /> */}
                    {/* <DayAndTime text="Working Hour" name="working_hours" btnText="Add Another Working Hour" /> */}
                    <Form.Item>
                        <Space>
                            <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            size="large"
                            block
                            style={{
                                height: '48px',
                                fontSize: '16px',
                                fontWeight: 600,
                                borderRadius: '8px',
                            }}
                            >
                                Save Changes
                            </Button>
                            <Button onClick={(e) => navigate(-1)}>Back</Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default AddAgent;